module.exports = __webpack_public_path__ + "static/media/s_v10_t9_1.67f8efa5.mp3";